import { render, staticRenderFns } from "./SchoolPeople.vue?vue&type=template&id=c093fcea&scoped=true"
import script from "./SchoolPeople.vue?vue&type=script&setup=true&lang=ts"
export * from "./SchoolPeople.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SchoolPeople.vue?vue&type=style&index=0&id=c093fcea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c093fcea",
  null
  
)

export default component.exports